module.exports = __webpack_public_path__ + "static/media/ukvac-logo.4ad84d72.png";


//////////////////
// WEBPACK FOOTER
// ./src/ukvac-logo.png
// module id = 104
// module chunks = 0